import { defineMessages } from 'react-intl-next';

import type { i18nType } from '../../../../../common/types';

type CloseDateLabelsType = Record<string, i18nType>;

export const closeDateLabels: CloseDateLabelsType = defineMessages({
	anytime: {
		id: 'search-page.filter.close.date.anytime',
		defaultMessage: 'Anytime',
		description: 'Close date filter anytime option label',
	},
	custom: {
		id: 'search-page.filter.close.date.custom',
		defaultMessage: 'Specific date',
		description: 'Close date filter specific date option label',
	},
});
